module.exports = __webpack_public_path__ + "static/media/bank_100_01.fa731c04.png";